import React, { useEffect } from 'react';
import Modal from 'react-responsive-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

const RejectConfirmModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  onPause?: any;
  onConfirm?: any;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        oProps.onConfirm();
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
    };
  }, []);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'optionCustomOverlay',
        modal: 'rejectConfirmModal',
        root: 'customModalRoot',
      }}
      closeOnOverlayClick={false}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modal">
          <img src={`${process.env.PUBLIC_URL}/svg/ic_error_triangle.svg`} alt="ic" />
          <p className="subTitle">{'주문을 취소하시면 되돌릴 수 없습니다\n신중히 결정해주세요'}</p>

          <button className="confirmButton" onClick={oProps.onConfirm}>
            네, 취소할게요
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default RejectConfirmModal;

const Style = styled.div`
  .modal {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  img {
    margin-top: 10px;
  }

  .subTitle {
    padding: 20px 0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    white-space: pre-line;
  }

  .confirmButton {
    width: 100%;
    padding: 16px;
    font-size: 20px;
    line-height: 28px;
    border-radius: 10px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    margin: 0;
    color: #fff;
    background: #ff6060;
    border: 1px solid #ff6060;
  }

  @media (max-width: 900px) {
    .subTitle {
      font-size: 16px;
      line-height: 24px;
    }

    .confirmButton {
      padding: 12px;
      margin-bottom: 20px;
    }
  }
`;
